import traits from './traits';

class Variant {
  constructor(variantJson) {
    this.traits = variantJson.traits;
    this.fileUrl = variantJson.file_url;
    this.fileSize = variantJson.file_size;
    this.downloadText = variantJson.download_text;
  }

  get operatingSystem() {
    return this.traits.find(trait => trait.uuid === traits.operatingSystem.uuid);
  }

  get operatingSystemTraits() {
    return this.traits.filter(trait => trait.uuid === traits.operatingSystem.uuid);
  }

  get fileTypes() {
    return this.traits.filter(trait => trait.uuid === traits.fileType.uuid);
  }

  get fileTypeNames() {
    return this.fileTypes.map(fileType => fileType.value_name).sort();
  }
}

export default Variant;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/digital_listings/variant.js